/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 ClDrawHbar 的实体定义

import {
    _drawBegin,
    _drawEnd,
    _drawHBar,
    _drawHBarZero,
} from './cl.draw'
import {
    initCommonInfo
} from './cl.chart.init'

import { getValue } from '../datas/cl.data'

// 创建时必须带入父类，后面的运算定位都会基于父节点进行；
// 这个类仅仅是画图, 因此需要把可以控制的rect传入进来
/**
 * Class representing ClDrawHbar
 * @export
 * @class ClDrawHbar
 */
export default class ClDrawHbar {
    /**

     * Creates an instance of ClDrawHbar.
     * @param {Object} father
     * @param {Object} rectMain
     */
    constructor(father, rectMain) {
        initCommonInfo(this, father)
        this.rectMain = rectMain

        this.father = father.father
        this.dataLayer = father.father.dataLayer

        this.axisYdata = father.axisYdata
        this.axisXdata = father.axisXdata
        // this.info = {}
    }
    drawZero() {
        // console.log(this.axisXdata, this.axisYdata);
        _drawBegin(this.context, this.color[this.info.maxcolor])
        for (let idx = this.axisYdata.minIndex; idx <= this.axisYdata.maxIndex; idx++) {
            
            const valueY = getValue(this.data, this.info.fieldY, idx)
            const valueX = getValue(this.data, this.info.fieldX, idx)
            if (valueX >= 0.000001) {
                _drawHBarZero(this.context, {
                    filled: true,
                    axisYdata: this.axisYdata,
                    unitX: this.axisXdata.unitX,
                    maxmin: this.maxmin,
                    rect: this.rectMain,
                    scale: this.scale,
                    fillclr: this.color[this.info.maxcolor]
                },
                valueX, valueY)
            }
        }
        _drawEnd(this.context)
        _drawBegin(this.context, this.color[this.info.mincolor])
        for (let idx = this.axisYdata.minIndex; idx <= this.axisYdata.maxIndex; idx++) {
            const valueY = getValue(this.data, this.info.fieldY, idx)
            const valueX = getValue(this.data, this.info.fieldX, idx)
            if (valueX <= -0.000001) {
                _drawHBarZero(this.context, {
                    filled: true,
                    axisYdata: this.axisYdata,
                    unitX: this.axisXdata.unitX,
                    unitY: this.axisYdata.unitY,
                    spaceY: this.axisYdata.spaceY,
                    maxmin: this.maxmin,
                    rect: this.rectMain,
                    scale: this.scale,
                    fillclr: this.color[this.info.mincolor]
                },
                valueX, valueY)
            }
        }
        _drawEnd(this.context)
    }
    onPaint(key) {
        if (key !== undefined) this.hotKey = key
        this.data = this.father.getData(this.hotKey)
        // console.log(this.info);
        if (this.info == undefined) return

        if (this.info.showstyle === 'zero') {
            this.maxmin = {
                min: this.axisXdata.min,
                max: this.axisXdata.max
            }
            this.drawZero()
        } else {
            this.drawZero()
        }
    }


}